
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","data-name":"Layer 1","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.68 1.167l-.021-.007-2.715-.9a5.017 5.017 0 00-2.9-.079L9.468 1.8a3.025 3.025 0 01-2.048-.18l-.5-.232A5 5 0 000 6v12.075a5.013 5.013 0 003.6 4.8l2.869.9A4.991 4.991 0 007.964 24a4.592 4.592 0 001.336-.181l5.8-1.6a3 3 0 011.617.013l2.343.676A4 4 0 0024 19.021V5.876a5.01 5.01 0 00-3.32-4.709zM4.176 20.959A3.013 3.013 0 012 18.075V6a2.953 2.953 0 011.336-2.5A3 3 0 015 3a2.9 2.9 0 011.112.222s.745.319.887.37v18.25zM9 21.827V3.879a5.105 5.105 0 001.006-.155L15 2.273V20.2zm13-2.806a2 2 0 01-2.433 1.954L17 20.252V2.075l3.018.979A3.006 3.006 0 0122 5.876z"}})])
          )
        }
      }
    